import { LOAD_CHAT_INELIGIBLE_MODAL_CONTAINER, CLOSE_CHAT_INELIGIBLE_MODAL_CONTAINER } from '../constants/ActionTypes';

export function loadChatIneligibleModalContainer() {
  return (dispatch) =>
    dispatch({
      type: LOAD_CHAT_INELIGIBLE_MODAL_CONTAINER,
    });
}

export function closeChatIneligibleModalContainer() {
  return (dispatch) =>
    dispatch({
      type: CLOSE_CHAT_INELIGIBLE_MODAL_CONTAINER,
    });
}
